module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/lottery/lottery-applicant-view/lottery-applicant-view.component.css
// module id = ./src/app/allocation/lottery/lottery-applicant-view/lottery-applicant-view.component.css
// module chunks = main